
import Constant from "@constant/index.js";

export default class BaseView{
    constructor(model){
        this._el = null;
        this._model = model;
    }

    getInvalidInfo(item){
        if(!item){
            item = this._model._items[0];
        }
        let res = {msg:"",cls:""};
        if(this._model._parent._stock <= 0){
            return {msg:Constant.MSG.INVALID, cls:'disable'};
        }
        if(!this._model._parent._marketable){
            return {msg:Constant.MSG.INVALID, cls:'disable'};
        }
        if(item._invalid){
            return {msg:Constant.MSG.INVALID, cls:'disable'};
        }
        if(this._model._parent._invalid){
            return {msg:Constant.MSG.INVALID, cls:'disable'};
        }

        return res;
    }

    render(){

    }

    registerEvent(){
        let that = this;
        let eventNams = ["click","blur"];
        eventNams.forEach(ename=>{
            let tmp = "le" + ename;
            this._el.find("["+tmp+"]").each((index, item)=>{
                let eventHandlerName = $(item).attr(tmp);
                (function(dom, eventHandlerName){
                    $(dom).on(ename, function(){
                        that._eventCenter[eventHandlerName](this, {view:that})
                    });
                })(item, eventHandlerName);
            })
        })
    }
}